import { RatioTypeUnion } from '@ve-pro/types/track.type'
import { AddProjectQuery } from '@pt/api/veditor/type'
import type { TemplatePreviews } from '@ve-pro/api/project/type'

export enum VideoTemplateType {
  personal = 'personal',
  common = 'common',
  content = 'content',
}

export interface VideoTemplateParams {
  keyword: string
  // 素材替换 1:支持 2:不支持
  is_replaceable: string | 1 | 2
  order: string
  page: number
  types: VideoTemplateType[]
  page_size: number
  show_statuses: number[]
  audit_statuses: string[]
  search_field: string
  search_time?: string[]
  start_date: string
  end_date: string
  tag_ids: string[]
}

export interface VideoTemplateItemType {
  project: any
  adv_id: number
  audit_status: string
  copy_template_id: number
  cover_previews: TemplatePreviews
  cover_url: string
  created_time: number
  deleted_time: number
  duration: number
  id: number
  is_replaceable: number
  name: string
  name_en: string
  name_jp: string
  language: string
  previews: TemplatePreviews
  project_id: number
  ratios: string
  replace_image_count: number
  replace_text_count: number
  replace_video_count: number
  show_status: number
  type: string
  tag_ids: string
  updated_time: number
  loading?: boolean
}

export interface VideoTemplateCopyParams {
  id: VideoTemplateItemType['id']
  name: VideoTemplateItemType['name']
  type?: VideoTemplateItemType['type']
}

export interface VideoTemplateCreateParams {
  name: VideoTemplateItemType['name']
  language: string
  // 多语言列表
  languages?: string[] | string
  ratios: RatioTypeUnion[]
  project_id?: number
  type: VideoTemplateType
}

export interface SearchConfigType {
  order: string
  keyword: string
  search_field: string
  ratios: RatioTypeUnion[]
  duration_min: number
  duration_max: number
  duration_unit: 'sec' | 'min' | 'hour'
  replace_video_count_min: number
  replace_video_count_max: number
  replace_image_count_min: number
  replace_image_count_max: number
  replace_text_count_min: number
  replace_text_count_max: number
  types: VideoTemplateType | string
  filter_bar?: string
  filter_visible?: boolean
  tag_ids?: string
  industry_ids?: string
  page: number
  page_size: number
}

export interface PublicVideoTemplateItemType {
  adv_id: number
  audit_status: string
  copy_template_id: number
  cover_url: string
  created_time: number
  deleted_time: number
  duration: number
  id: number
  is_replaceable: number
  name: string
  name_en: string
  name_jp: string
  previews: { [x in string]: TemplatePreviews }
  cover_previews: { [x in string]: TemplatePreviews }
  project: null | {
    duration: number
    ratios: RatioTypeUnion
  }
  splitList: {
    id: number
    name: string
    name_en: string
    cover_url: string
    duration: number
    previews: string
    ratio: RatioTypeUnion
  }[]
  project_id: number
  ratios: string
  main_video_width: number
  main_video_height: number
  replace_image_count: number
  replace_text_count: number
  replace_video_count: number
  show_status: number
  type: string
  tag_ids: string
  updated_time: number
  language: string
  industry_ids?: string
  only_inner?: number
}

export interface PublicVideoTemplateModel {
  list: PublicVideoTemplateItemType[]
  total: number
  loading: boolean
}

export interface CreateFromTemplateParams extends AddProjectQuery {
  id: PublicVideoTemplateItemType['project_id']
}
